;

(function() {
	document.addEventListener('mouseover', function(event) {
		if (window.getComputedStyle(event.target).getPropertyValue('--hover-stop')) {
			var t = window.getComputedStyle(event.target);
			var tgt = t.getPropertyValue('--hover-target');
			var el;
			if (tgt)
				el = event.target.querySelector('.' + tgt.replace(/^\s*/, '').replace(/\s*$/, ''));
			else
				el = event.target;
			
			var baseProperty = (event.target.style.getPropertyValue('--hover-property') || 'opacity').replace(/^\s*/, '').replace(/\s*$/, '');
			event.target.style.setProperty('--hover-init', window.getComputedStyle(el).getPropertyValue(baseProperty));
			require('class-list').default.add(event.target, 'stopped');
		}
	});
	document.addEventListener('mouseout', function(event) {
		if (window.getComputedStyle(event.target).getPropertyValue('--hover-stop')) {
			event.target.style.removeProperty('--hover-init');
			require('class-list').default.remove(event.target, 'stopped');
		}
	});
})();

;